import { ROUTES } from '../constants/routes';
import { store } from '@/store';

export const getDefaultRoute = () => (store.getState().auth.login?.token ? '/' : ROUTES.LOGIN);
